<template>
<div>

  <!-- <p class="mt-4 text-xs text-gray-400 uppercase">
    Step 2 of 6
  </p> -->

  <label
    for="location"
    class="text-xl text-gray-700 font-medium sm:text-2xl"
  >
    <strong>{{ enquiry.initialName }}!</strong> Is there a particular subject you need help with?
  </label>

  
  <VSelect 
    v-model="search"
    :options="subjects"
    label="Description"
    :clear-search-on-select="true"
    placeholder="Search…"
    class="find-a-tutor-search flex-1 mt-4 block w-full h-13 max-w-md rounded-md border-gray-200 text-base placeholder-gray-500 shadow-sm focus:border-blue-500 focus:ring-blue-500"
  >
    <template #no-options="{ search, searching }">
      <div class="pl-3 text-sm text-gray-600 text-left leading-relaxed">
        <template v-if="searching">
          No results found for <strong>{{ search }}</strong> but we may still be able to help.
          For now, you can  
          <button type="button" @click="skip" class="text-blue-500 font-medium hover:underline">
            skip this step
          </button>
          and detail your requirements later.
        </template>
      </div>
    </template>
    <template #option="{ Description }">
      <div class="-mx-5 px-3">
        {{ Description }}
      </div>
    </template>
  </VSelect>


  <button 
    type="button" 
    @click="skip"
    class="self-start flex flex-col mt-12 text-left group"
  >
    <span class="text-sm text-blue-500 font-medium group-hover:underline">
      I’m not sure
    </span>
    <span class="text-xs text-gray-500">
      Skip this step and provide details later
    </span>
  </button>


</div>
</template>
<script>

import vSelect from 'vue-select'

import SearchService from '@/services/SearchServices'

const searchService = new SearchService()

export default {
  components: {
    'VSelect': vSelect,
  },
  props: {
    enquiry: Object,
  },
  data() {
    return {
      loading: true,
      search: null,
      subjects: [],
    }
  },
  methods: {
    skip() {
      this.$emit('updateEnquiry', { subjectId: null })
      this.$router.push({name: 'FindATutor-Location'})
    },
  },
  watch: {
    search(newVal) {
      this.$emit('updateEnquiry', { subjectId: newVal.Id })
      this.$router.push({name: 'FindATutor-Location'})
    }
  },
  async mounted() {
    const response = await searchService.getSubjects(this.enquiry.levelId, 9999)
    this.subjects =  response.data
    this.loading = false
  }
}
</script>

<style lang="scss" scoped>

</style>